// Vuex
import { GetterTree } from 'vuex'

// Root state
import { State as RootState } from '@/store/state'
// Module state
import { MatchState } from './state'

import {
  canGotoNextPeriod,
  durationOfCurrentPeriod,
  isAtEndOfCurrentPeriod,
  periodProgressPercentage,
  timeNumericValue,
  hasNextPeriod,
  extraTimeNumericValue,
} from 'match-central-shared/dist/game-clock'

import { prettifyTimeFromNumeric } from 'match-central-shared/dist/utility/time'

export default <GetterTree<MatchState, RootState>>{
  /**
   * Current game clock numeric value
   */
  timeNumericValue(state): number {
    if (!state.match) {
      return 0
    }

    if (!state.match.gcState) {
      return 0
    }

    return timeNumericValue(state.match, state.realtime.timestamp)
  },

  /**
   * Game clock Extra time Value
   *
   * Empty '' if not active
   */
  extraTimeValue(state): string {
    if (!state.match) {
      return ''
    }

    if (!state.match.gcState) {
      return ''
    }
    const extraTimeValue = extraTimeNumericValue(state.match, state.realtime.timestamp)

    return extraTimeValue === '' ? '' : prettifyTimeFromNumeric(extraTimeValue)
  },

  /**
   * Get current game clock text (prettified)
   */
  currentGameClockPretty(_state, getters): string {
    // return '0:40'
    return prettifyTimeFromNumeric(getters.timeNumericValue)
  },

  /**
   * Duration of current period
   */
  durationOfCurrentPeriod(state): number {
    if (!state.match) {
      return 0
    }

    return durationOfCurrentPeriod(state.match)
  },

  /**
   * Get current period progress percentage
   */
  periodProgressPercentage(state): number {
    if (!state.match) {
      return 0
    }

    return periodProgressPercentage(state.match, state.realtime.timestamp)
  },

  /**
   * Can go to next period?
   * This is possible (true) when:
   *  - clock is paused
   *  - is at end of current period
   */
  canGotoNextPeriod(state): boolean {
    if (!state.match) {
      return false
    }

    return canGotoNextPeriod(state.match, state.realtime.timestamp)
  },

  /**
   * Match has next period?
   *
   * @param state
   * @returns
   */
  hasNextPeriod(state): boolean {
    if (!state.match) {
      return false
    }

    return hasNextPeriod(state.match)
  },

  /**
   * Is at end of current period?
   *s
   * @param state
   * @returns
   */
  isAtEndOfCurrentPeriod(state): boolean {
    if (!state.match) {
      return false
    }

    return isAtEndOfCurrentPeriod(state.match, state.realtime.timestamp)
  },

  /**
   * Is ready for next period
   * @param state
   * @returns
   */
  isReadyForNextPeriod(state, getters): boolean {
    if (!state.match) {
      return false
    }

    return getters.isAtEndOfCurrentPeriod && state.match.gcState !== 'STARTED'
  },
}
